import { IFacility } from '../facility/i-facility.interface';
import { IInvoiceSummary } from './i-invoicesummary.interface';

import { ArInvoiceType } from 'app/shared/arInvoiceType.model';
import { BusinessObject } from '../../shared/business-object.model';
import { Facility } from '../facility/facility.model';

export class InvoiceSummary extends BusinessObject implements IInvoiceSummary {
	id: number;
	invoiceNumber: string;
	invoiceDate: Date;
	facility: IFacility;
	shopName: string;
	shopId: number;
	shopCode: string;
	shopAccountingSystemId: string;
	laborCharge: number;
	materialCharge: number;
	totalCharge: number;
	total: number;
	invoiceReceivedDate: Date;
	invoiceProcessedDate: Date;
	sentToIntacct: boolean;
	leaseId: number;
	leaseNumber: string;
	customerName: string;
	railroadName: string;
	railroadMark: string;
	carOwnerName: string;
	carOwnerCode: string;
	billToType: string;
	railcarMark : string;
	railcarMarkWithoutSpace : string;
	invoiceType: ArInvoiceType;

	selected: boolean;
	accountingInvoiceDate: Date;
	accountingDueDate: Date;
	loadingIntacctData: boolean;
	glPostingDate: Date;
	accountingSystemDocId: string;
	postedDate: Date;
	hasOpenPrograms: boolean;
	hasError: boolean;
	isWorked: boolean;
	get Type(): string {
	return this.invoiceNumber.startsWith('RB') ? 'Customer' : this.invoiceNumber.startsWith('RO') ? 'Owner' : 'Railroad';
	}

	constructor(invoiceSummary: InvoiceSummary) {
		super(invoiceSummary);
		this.railcarMarkWithoutSpace = this.railcarMark?.replace(' ', '');
	}
}